import React from 'react';
import { ProductType } from '@/@types';
import { Trans } from '@lingui/react/macro';
import clsx from 'clsx';
import { Runtime } from '@/components/core/components/molecules';
import { isProductOfType } from '@/services/api/parsers/utils';
import * as styles from './default.styles';

const DefaultDetails: React.FC<{ product: ProductType }> = ({ product }) => {
  const genres = product.subcategories.filter((sub) => {
    return sub.label === 'genre';
  });
  return (
    <section>
      {product.description && (
        <div className={styles.overview}>
          <div className={clsx(styles.title)}>
            <Trans>Overview</Trans>
          </div>
          <span className={styles.details}>{product.description}</span>
        </div>
      )}

      {isProductOfType(product, ['movies', 'series']) && genres.length > 0 && (
        <div className={styles.item}>
          <span className={styles.title}>
            <Trans>Genres</Trans>
          </span>
          <span className={styles.details}>
            {genres
              .map((x) => {
                return x.name;
              })
              .join(', ')}
          </span>
        </div>
      )}

      {isProductOfType(product, ['movies']) && (product.extraInfo.runtime || 0) > 0 && (
        <div className={styles.item}>
          <span className={styles.title}>
            <Trans>Duration</Trans>
          </span>
          <span className={styles.details}>
            <Runtime runtime={product.extraInfo.runtime || 0} />
          </span>
        </div>
      )}

      {isProductOfType(product, ['music']) && product.extraInfo.artists.length > 0 && (
        <>
          <div className={styles.item}>
            <span className={styles.title}>
              <Trans>Artists</Trans>
            </span>
            <span className={styles.details}>
              {product.extraInfo.artists
                .map((x) => {
                  return x.name;
                })
                .join(', ')}
            </span>
          </div>
          {product.extraInfo.duration && (
            <div className={styles.item}>
              <span className={styles.title}>
                <Trans>Duration</Trans>
              </span>
              <span className={styles.details}>
                <Runtime runtime={(product.extraInfo.duration || 0) / 60} />
              </span>
            </div>
          )}
        </>
      )}
    </section>
  );
};

export default DefaultDetails;
